import { render, staticRenderFns } from "./GlobalViolationsTable.vue?vue&type=template&id=7242fd48&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./GlobalViolationsTable.vue?vue&type=script&lang=js"
export * from "./GlobalViolationsTable.vue?vue&type=script&lang=js"
import style0 from "./GlobalViolationsTable.vue?vue&type=style&index=0&id=7242fd48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7242fd48",
  null
  
)

export default component.exports